export default "__VITE_ASSET__CIaBXpkp__"